import React from 'react';

import { useSessionPageHost } from '../session-page/host-context';

interface Props {
  selectedAudioSourceDevice: MediaDeviceInfo | undefined;
}

export const VolumeBar: React.FC<Props> = () => {
  const AudioVisualizer = useSessionPageHost().AudioVisualizer;
  return <AudioVisualizer />;
};
